/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaStudentePortafogliDTO { 
    id?: string;
    residuo?: number;
    pasti_residui?: number;
    costo_pasto?: number;
    costo_contributo?: number;
    saldo_iniziale?: number;
    pasti_usufruiti?: number;
}

